import { useEffect } from 'react';
import { Button } from '../../../../ui/button/button';
import { Input } from '../../../../ui/input/input';
import { PageLayout } from '../../../../ui/page-layout/page-layout';
import { useAuthenticate } from '../../hooks/use-authenticate/use-authenticate';
import { PageLoadingState } from '../../../../ui/page-loading-state/page-loading-state';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorMessage } from '../../../promo/components/error-message/error-message';
import { UserBodyParams } from '@repo/types/user';
import { SubmitHandler, useForm } from 'react-hook-form';

type SignInFormValues = UserBodyParams;

export const SignIn = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<SignInFormValues>();
  const { authenticate, isLoading, isError, isAuthenicated } =
    useAuthenticate();
  const location = useLocation();
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<SignInFormValues> = (event) => {
    authenticate(event);
  };

  useEffect(() => {
    const params = Object.fromEntries(new URLSearchParams(location.search));
    if (params.redirect && isAuthenicated) {
      navigate(params.redirect);
    }
  }, [isAuthenicated]);

  if (isLoading) {
    return <PageLoadingState />;
  }

  return (
    <PageLayout>
      {isAuthenicated ? (
        <p>Already signed in!</p>
      ) : (
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-1">
            <label>Email</label>
            <Input
              type="email"
              aria-label="Email input field"
              placeholder="Email"
              {...register('email', { required: 'Email is required' })}
            />
            {errors.email && <ErrorMessage text={`${errors.email.message}`} />}
          </div>
          <div className="flex flex-col gap-1">
            <label>Password</label>
            <Input
              type="password"
              aria-label="Password input field"
              placeholder="Password"
              {...register('password', { required: 'Password is required' })}
            />
            {errors.password && (
              <ErrorMessage text={`${errors.password.message}`} />
            )}
          </div>
          {isError && <ErrorMessage text="Incorrect details" />}
          <Button>Sign in</Button>
        </form>
      )}
    </PageLayout>
  );
};
